// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/tsdb/v1/tsdb.proto" (package "c1.api.tsdb.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { SortDirection } from "../../../models/api/v1/pagination";
import { TaskType } from "../../task/v1/task";
import { App } from "../../app/v1/app";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.tsdb.v1.RawMetricItem
 */
export interface RawMetricItem {
    /**
     * @generated from protobuf field: string tenant_id = 1
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string metric_id = 2
     */
    metricId: string;
    /**
     * @generated from protobuf field: int64 value = 4
     */
    value: number;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 3
     */
    timestamp?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 5
     */
    expiresAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.tsdb.v1.TSDBMetricServiceGetTopValuesRequest
 */
export interface TSDBMetricServiceGetTopValuesRequest {
    /**
     * @generated from protobuf field: repeated string metric_names = 1
     */
    metricNames: string[];
    /**
     * @generated from protobuf field: string label = 2
     */
    label: string;
    /**
     * @generated from protobuf field: c1.api.tsdb.v1.MetricType metric_type = 3
     */
    metricType: MetricType;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start_time = 4
     */
    startTime?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end_time = 5
     */
    endTime?: Timestamp;
    /**
     * @deprecated
     * @generated from protobuf field: int64 num_results = 6 [deprecated = true]
     */
    numResults: number;
    /**
     * Aggregation type for gauge metrics. Defaults to average.
     *
     * @generated from protobuf field: c1.api.tsdb.v1.AggregationType aggregation_type = 7
     */
    aggregationType?: AggregationType;
    /**
     * @generated from protobuf field: int32 page_size = 8
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 9
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.tsdb.v1.TSDBMetricServiceGetTopValuesResponse
 */
export interface TSDBMetricServiceGetTopValuesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.tsdb.v1.TopValueEntry list = 1
     */
    list: TopValueEntry[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.tsdb.v1.TopValueEntry
 */
export interface TopValueEntry {
    /**
     * @generated from protobuf oneof: object
     */
    object: {
        oneofKind: "app";
        /**
         * @generated from protobuf field: c1.api.app.v1.App app = 1
         */
        app: App;
    } | {
        oneofKind: "department";
        /**
         * @generated from protobuf field: string department = 2
         */
        department: string;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: int64 value = 3
     */
    value: number;
}
/**
 * @generated from protobuf message c1.api.tsdb.v1.TSDBMetricServiceGetManyMetricsRequest
 */
export interface TSDBMetricServiceGetManyMetricsRequest {
    /**
     * @generated from protobuf field: repeated c1.api.tsdb.v1.MetricRollupRequestSet request_sets = 1
     */
    requestSets: MetricRollupRequestSet[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start_time = 2
     */
    startTime?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end_time = 3
     */
    endTime?: Timestamp;
    /**
     * @generated from protobuf field: optional int32 target_point_density = 4
     */
    targetPointDensity?: number;
}
/**
 * @generated from protobuf message c1.api.tsdb.v1.MetricRollupRequestSet
 */
export interface MetricRollupRequestSet {
    /**
     * @generated from protobuf field: repeated c1.api.tsdb.v1.MetricRollupRequest requests = 1
     */
    requests: MetricRollupRequest[];
    /**
     * Aggregation type for gauge metrics. If not set, defaults to average.
     *
     * @generated from protobuf field: c1.api.tsdb.v1.AggregationType aggregation_type = 2
     */
    aggregationType?: AggregationType;
    /**
     * @generated from protobuf field: c1.api.tsdb.v1.MetricType metric_type = 3
     */
    metricType: MetricType;
}
/**
 * specifies that gauge metrics should be aggregated by calculating the average.
 *
 * @generated from protobuf message c1.api.tsdb.v1.GaugeAverageAggregation
 */
export interface GaugeAverageAggregation {
}
/**
 * specifies that gauge metrics should be aggregated by calculating a percentile value.
 *
 * @generated from protobuf message c1.api.tsdb.v1.GaugePercentileAggregation
 */
export interface GaugePercentileAggregation {
    /**
     * The percentile to compute (0-100). For example, 95 for 95th percentile.
     *
     * @generated from protobuf field: int32 percentile = 1
     */
    percentile: number;
}
/**
 * AggregationType defines how gauge metrics should be aggregated over a time period.
 *
 * @generated from protobuf message c1.api.tsdb.v1.AggregationType
 */
export interface AggregationType {
    /**
     * @generated from protobuf oneof: type
     */
    type: {
        oneofKind: "gaugeAverage";
        /**
         * Compute the average of all gauge values in the period.
         *
         * @generated from protobuf field: c1.api.tsdb.v1.GaugeAverageAggregation gauge_average = 1
         */
        gaugeAverage: GaugeAverageAggregation;
    } | {
        oneofKind: "gaugePercentile";
        /**
         * Compute a specific percentile of gauge values in the period.
         *
         * @generated from protobuf field: c1.api.tsdb.v1.GaugePercentileAggregation gauge_percentile = 2
         */
        gaugePercentile: GaugePercentileAggregation;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.tsdb.v1.MetricRollupRequest
 */
export interface MetricRollupRequest {
    /**
     * @generated from protobuf field: string metric_name = 1
     */
    metricName: string;
    /**
     * @generated from protobuf field: map<string, string> labels = 2
     */
    labels: {
        [key: string]: string;
    };
    /**
     * @deprecated
     * @generated from protobuf field: c1.api.tsdb.v1.MetricType metric_type = 3 [deprecated = true]
     */
    metricType: MetricType;
}
/**
 * @generated from protobuf message c1.api.tsdb.v1.TSDBMetricServiceGetRollupsRequest
 */
export interface TSDBMetricServiceGetRollupsRequest {
    /**
     * @generated from protobuf field: string metric_name = 1
     */
    metricName: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start_time = 2
     */
    startTime?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end_time = 3
     */
    endTime?: Timestamp;
    /**
     * @generated from protobuf field: map<string, string> labels = 4
     */
    labels: {
        [key: string]: string;
    }; // ex: {app_id: "2xhYo8e4hdhjasdh"}
    /**
     * @generated from protobuf field: c1.api.tsdb.v1.MetricType metric_type = 5
     */
    metricType: MetricType;
    /**
     * @generated from protobuf field: optional int32 target_point_density = 6
     */
    targetPointDensity?: number; // falls back to default value of 50
    /**
     * default is average for gauge, for counters we only have summation
     *
     * @generated from protobuf field: c1.api.tsdb.v1.AggregationType aggregation_type = 7
     */
    aggregationType?: AggregationType;
}
/**
 * @generated from protobuf message c1.api.tsdb.v1.TSDBMetricServiceGetRollupsResponse
 */
export interface TSDBMetricServiceGetRollupsResponse {
    /**
     * @generated from protobuf field: c1.api.tsdb.v1.Granularity granularity = 1
     */
    granularity: Granularity;
    /**
     * @generated from protobuf field: repeated c1.api.tsdb.v1.Rollup rollups = 2
     */
    rollups: Rollup[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp first_observed_at = 4
     */
    firstObservedAt?: Timestamp;
    /**
     * @generated from protobuf field: bool metric_found = 6
     */
    metricFound: boolean;
    /**
     * the aggregated value across all rollups
     *
     * @generated from protobuf field: int64 aggregate_value = 7
     */
    aggregateValue: number;
}
/**
 * @generated from protobuf message c1.api.tsdb.v1.Rollup
 */
export interface Rollup {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 1
     */
    timestamp?: Timestamp;
    /**
     * @generated from protobuf field: int64 value = 2
     */
    value: number; // this will be the delta value for counters, and average/percentile for gauges
    /**
     * @generated from protobuf field: bool data_available = 3
     */
    dataAvailable: boolean;
    /**
     * @generated from protobuf field: bool data_collection_pending = 4
     */
    dataCollectionPending: boolean;
}
/**
 * @generated from protobuf message c1.api.tsdb.v1.TSDBMetricServiceGetManyMetricsResponse
 */
export interface TSDBMetricServiceGetManyMetricsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.tsdb.v1.MetricRollupResponse metric_rollups = 1
     */
    metricRollups: MetricRollupResponse[];
    /**
     * @generated from protobuf field: c1.api.tsdb.v1.Granularity granularity = 2
     */
    granularity: Granularity;
    /**
     * the aggregate value across all sets if possible to calculate
     *
     * @generated from protobuf field: optional int64 aggregate_value = 3
     */
    aggregateValue?: number;
}
/**
 * @generated from protobuf message c1.api.tsdb.v1.MetricRollupResponse
 */
export interface MetricRollupResponse {
    /**
     * @generated from protobuf field: repeated string metric_name = 1
     */
    metricName: string[];
    /**
     * @generated from protobuf field: repeated c1.api.tsdb.v1.Rollup rollups = 2
     */
    rollups: Rollup[];
    /**
     * @generated from protobuf field: bool metric_found = 3
     */
    metricFound: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp first_observed_at = 4
     */
    firstObservedAt?: Timestamp;
    /**
     * the aggregated value across all rollups
     *
     * @generated from protobuf field: int64 aggregate_value = 5
     */
    aggregateValue: number;
}
/**
 * @generated from protobuf message c1.api.tsdb.v1.GetUserResponseTimeStatsRequest
 */
export interface GetUserResponseTimeStatsRequest {
    /**
     * Filter by task types (grant, revoke, certify). If empty, all types are included.
     *
     * @generated from protobuf field: repeated c1.api.task.v1.TaskType task_types = 1
     */
    taskTypes: TaskType[];
    /**
     * Time range for the query
     *
     * @generated from protobuf field: google.protobuf.Timestamp start_time = 2
     */
    startTime?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end_time = 3
     */
    endTime?: Timestamp;
    /**
     * Number of results per page (1-100)
     *
     * @generated from protobuf field: int32 page_size = 4
     */
    pageSize: number;
    /**
     * Column to sort by
     *
     * @generated from protobuf field: c1.api.tsdb.v1.UserResponseTimeSortColumn sort_column = 5
     */
    sortColumn: UserResponseTimeSortColumn;
    /**
     * Sort direction (ascending or descending) defaults to descending
     *
     * @generated from protobuf field: c1.models.api.v1.SortDirection sort_direction = 6
     */
    sortDirection: SortDirection;
    /**
     * Pagination token for fetching the next page
     *
     * @generated from protobuf field: string page_token = 7
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.tsdb.v1.GetUserResponseTimeStatsResponse
 */
export interface GetUserResponseTimeStatsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.tsdb.v1.UserResponseTimeEntry list = 1
     */
    list: UserResponseTimeEntry[];
    /**
     * Token for fetching the next page, empty if no more results
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * Total number of users with response time data
     *
     * @generated from protobuf field: int32 total_count = 3
     */
    totalCount: number;
}
/**
 * @generated from protobuf message c1.api.tsdb.v1.UserResponseTimeEntry
 */
export interface UserResponseTimeEntry {
    /**
     * The user ID
     *
     * @generated from protobuf field: string user_id = 1
     */
    userId: string;
    /**
     * Total number of actions taken by the user
     *
     * @generated from protobuf field: int64 total_actions = 2
     */
    totalActions: number;
    /**
     * P50 response time in seconds
     *
     * @generated from protobuf field: int64 p50_seconds = 3
     */
    p50Seconds: number;
    /**
     * P90 response time in seconds
     *
     * @generated from protobuf field: int64 p90_seconds = 4
     */
    p90Seconds: number;
    /**
     * P99 response time in seconds
     *
     * @generated from protobuf field: int64 p99_seconds = 5
     */
    p99Seconds: number;
}
/**
 * @generated from protobuf enum c1.api.tsdb.v1.Granularity
 */
export enum Granularity {
    /**
     * @generated from protobuf enum value: GRANULARITY_UNSPECIFIED = 0;
     */
    GRANULARITY_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: GRANULARITY_1_HOUR = 1;
     */
    GRANULARITY_1_HOUR = 1,
    /**
     * @generated from protobuf enum value: GRANULARITY_4_HOUR = 2;
     */
    GRANULARITY_4_HOUR = 2,
    /**
     * @generated from protobuf enum value: GRANULARITY_1_DAY = 3;
     */
    GRANULARITY_1_DAY = 3,
    /**
     * @generated from protobuf enum value: GRANULARITY_1_WEEK = 4;
     */
    GRANULARITY_1_WEEK = 4
}
/**
 * @generated from protobuf enum c1.api.tsdb.v1.MetricType
 */
export enum MetricType {
    /**
     * @generated from protobuf enum value: METRIC_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: METRIC_TYPE_GAUGE = 1;
     */
    GAUGE = 1,
    /**
     * @generated from protobuf enum value: METRIC_TYPE_DELTA_COUNTER = 2;
     */
    DELTA_COUNTER = 2
}
/**
 * Sort column options for user response time stats
 *
 * @generated from protobuf enum c1.api.tsdb.v1.UserResponseTimeSortColumn
 */
export enum UserResponseTimeSortColumn {
    /**
     * @generated from protobuf enum value: USER_RESPONSE_TIME_SORT_COLUMN_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: USER_RESPONSE_TIME_SORT_COLUMN_P50 = 1;
     */
    P50 = 1,
    /**
     * @generated from protobuf enum value: USER_RESPONSE_TIME_SORT_COLUMN_P90 = 2;
     */
    P90 = 2,
    /**
     * @generated from protobuf enum value: USER_RESPONSE_TIME_SORT_COLUMN_P99 = 3;
     */
    P99 = 3,
    /**
     * @generated from protobuf enum value: USER_RESPONSE_TIME_SORT_COLUMN_TOTAL_ACTIONS = 4;
     */
    TOTAL_ACTIONS = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class RawMetricItem$Type extends MessageType<RawMetricItem> {
    constructor() {
        super("c1.api.tsdb.v1.RawMetricItem", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "metric_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "value", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 5, name: "expires_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<RawMetricItem>): RawMetricItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenantId = "";
        message.metricId = "";
        message.value = 0;
        if (value !== undefined)
            reflectionMergePartial<RawMetricItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RawMetricItem): RawMetricItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant_id */ 1:
                    message.tenantId = reader.string();
                    break;
                case /* string metric_id */ 2:
                    message.metricId = reader.string();
                    break;
                case /* int64 value */ 4:
                    message.value = reader.int64().toNumber();
                    break;
                case /* google.protobuf.Timestamp timestamp */ 3:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* google.protobuf.Timestamp expires_at */ 5:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RawMetricItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant_id = 1; */
        if (message.tenantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenantId);
        /* string metric_id = 2; */
        if (message.metricId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.metricId);
        /* google.protobuf.Timestamp timestamp = 3; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* int64 value = 4; */
        if (message.value !== 0)
            writer.tag(4, WireType.Varint).int64(message.value);
        /* google.protobuf.Timestamp expires_at = 5; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.tsdb.v1.RawMetricItem
 */
export const RawMetricItem = new RawMetricItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TSDBMetricServiceGetTopValuesRequest$Type extends MessageType<TSDBMetricServiceGetTopValuesRequest> {
    constructor() {
        super("c1.api.tsdb.v1.TSDBMetricServiceGetTopValuesRequest", [
            { no: 1, name: "metric_names", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "metric_type", kind: "enum", T: () => ["c1.api.tsdb.v1.MetricType", MetricType, "METRIC_TYPE_"] },
            { no: 4, name: "start_time", kind: "message", T: () => Timestamp },
            { no: 5, name: "end_time", kind: "message", T: () => Timestamp },
            { no: 6, name: "num_results", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 7, name: "aggregation_type", kind: "message", T: () => AggregationType },
            { no: 8, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100, gte: 1 } } } },
            { no: 9, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "0", maxLen: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<TSDBMetricServiceGetTopValuesRequest>): TSDBMetricServiceGetTopValuesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.metricNames = [];
        message.label = "";
        message.metricType = 0;
        message.numResults = 0;
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<TSDBMetricServiceGetTopValuesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TSDBMetricServiceGetTopValuesRequest): TSDBMetricServiceGetTopValuesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string metric_names */ 1:
                    message.metricNames.push(reader.string());
                    break;
                case /* string label */ 2:
                    message.label = reader.string();
                    break;
                case /* c1.api.tsdb.v1.MetricType metric_type */ 3:
                    message.metricType = reader.int32();
                    break;
                case /* google.protobuf.Timestamp start_time */ 4:
                    message.startTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startTime);
                    break;
                case /* google.protobuf.Timestamp end_time */ 5:
                    message.endTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.endTime);
                    break;
                case /* int64 num_results = 6 [deprecated = true] */ 6:
                    message.numResults = reader.int64().toNumber();
                    break;
                case /* c1.api.tsdb.v1.AggregationType aggregation_type */ 7:
                    message.aggregationType = AggregationType.internalBinaryRead(reader, reader.uint32(), options, message.aggregationType);
                    break;
                case /* int32 page_size */ 8:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 9:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TSDBMetricServiceGetTopValuesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string metric_names = 1; */
        for (let i = 0; i < message.metricNames.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.metricNames[i]);
        /* string label = 2; */
        if (message.label !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.label);
        /* c1.api.tsdb.v1.MetricType metric_type = 3; */
        if (message.metricType !== 0)
            writer.tag(3, WireType.Varint).int32(message.metricType);
        /* google.protobuf.Timestamp start_time = 4; */
        if (message.startTime)
            Timestamp.internalBinaryWrite(message.startTime, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp end_time = 5; */
        if (message.endTime)
            Timestamp.internalBinaryWrite(message.endTime, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* int64 num_results = 6 [deprecated = true]; */
        if (message.numResults !== 0)
            writer.tag(6, WireType.Varint).int64(message.numResults);
        /* c1.api.tsdb.v1.AggregationType aggregation_type = 7; */
        if (message.aggregationType)
            AggregationType.internalBinaryWrite(message.aggregationType, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* int32 page_size = 8; */
        if (message.pageSize !== 0)
            writer.tag(8, WireType.Varint).int32(message.pageSize);
        /* string page_token = 9; */
        if (message.pageToken !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.tsdb.v1.TSDBMetricServiceGetTopValuesRequest
 */
export const TSDBMetricServiceGetTopValuesRequest = new TSDBMetricServiceGetTopValuesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TSDBMetricServiceGetTopValuesResponse$Type extends MessageType<TSDBMetricServiceGetTopValuesResponse> {
    constructor() {
        super("c1.api.tsdb.v1.TSDBMetricServiceGetTopValuesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TopValueEntry },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TSDBMetricServiceGetTopValuesResponse>): TSDBMetricServiceGetTopValuesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<TSDBMetricServiceGetTopValuesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TSDBMetricServiceGetTopValuesResponse): TSDBMetricServiceGetTopValuesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.tsdb.v1.TopValueEntry list */ 1:
                    message.list.push(TopValueEntry.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TSDBMetricServiceGetTopValuesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.tsdb.v1.TopValueEntry list = 1; */
        for (let i = 0; i < message.list.length; i++)
            TopValueEntry.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.tsdb.v1.TSDBMetricServiceGetTopValuesResponse
 */
export const TSDBMetricServiceGetTopValuesResponse = new TSDBMetricServiceGetTopValuesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TopValueEntry$Type extends MessageType<TopValueEntry> {
    constructor() {
        super("c1.api.tsdb.v1.TopValueEntry", [
            { no: 1, name: "app", kind: "message", oneof: "object", T: () => App },
            { no: 2, name: "department", kind: "scalar", oneof: "object", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "value", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<TopValueEntry>): TopValueEntry {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.object = { oneofKind: undefined };
        message.value = 0;
        if (value !== undefined)
            reflectionMergePartial<TopValueEntry>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TopValueEntry): TopValueEntry {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.App app */ 1:
                    message.object = {
                        oneofKind: "app",
                        app: App.internalBinaryRead(reader, reader.uint32(), options, (message.object as any).app)
                    };
                    break;
                case /* string department */ 2:
                    message.object = {
                        oneofKind: "department",
                        department: reader.string()
                    };
                    break;
                case /* int64 value */ 3:
                    message.value = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TopValueEntry, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.App app = 1; */
        if (message.object.oneofKind === "app")
            App.internalBinaryWrite(message.object.app, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string department = 2; */
        if (message.object.oneofKind === "department")
            writer.tag(2, WireType.LengthDelimited).string(message.object.department);
        /* int64 value = 3; */
        if (message.value !== 0)
            writer.tag(3, WireType.Varint).int64(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.tsdb.v1.TopValueEntry
 */
export const TopValueEntry = new TopValueEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TSDBMetricServiceGetManyMetricsRequest$Type extends MessageType<TSDBMetricServiceGetManyMetricsRequest> {
    constructor() {
        super("c1.api.tsdb.v1.TSDBMetricServiceGetManyMetricsRequest", [
            { no: 1, name: "request_sets", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MetricRollupRequestSet },
            { no: 2, name: "start_time", kind: "message", T: () => Timestamp },
            { no: 3, name: "end_time", kind: "message", T: () => Timestamp },
            { no: 4, name: "target_point_density", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<TSDBMetricServiceGetManyMetricsRequest>): TSDBMetricServiceGetManyMetricsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requestSets = [];
        if (value !== undefined)
            reflectionMergePartial<TSDBMetricServiceGetManyMetricsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TSDBMetricServiceGetManyMetricsRequest): TSDBMetricServiceGetManyMetricsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.tsdb.v1.MetricRollupRequestSet request_sets */ 1:
                    message.requestSets.push(MetricRollupRequestSet.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp start_time */ 2:
                    message.startTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startTime);
                    break;
                case /* google.protobuf.Timestamp end_time */ 3:
                    message.endTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.endTime);
                    break;
                case /* optional int32 target_point_density */ 4:
                    message.targetPointDensity = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TSDBMetricServiceGetManyMetricsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.tsdb.v1.MetricRollupRequestSet request_sets = 1; */
        for (let i = 0; i < message.requestSets.length; i++)
            MetricRollupRequestSet.internalBinaryWrite(message.requestSets[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp start_time = 2; */
        if (message.startTime)
            Timestamp.internalBinaryWrite(message.startTime, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp end_time = 3; */
        if (message.endTime)
            Timestamp.internalBinaryWrite(message.endTime, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* optional int32 target_point_density = 4; */
        if (message.targetPointDensity !== undefined)
            writer.tag(4, WireType.Varint).int32(message.targetPointDensity);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.tsdb.v1.TSDBMetricServiceGetManyMetricsRequest
 */
export const TSDBMetricServiceGetManyMetricsRequest = new TSDBMetricServiceGetManyMetricsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MetricRollupRequestSet$Type extends MessageType<MetricRollupRequestSet> {
    constructor() {
        super("c1.api.tsdb.v1.MetricRollupRequestSet", [
            { no: 1, name: "requests", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MetricRollupRequest },
            { no: 2, name: "aggregation_type", kind: "message", T: () => AggregationType },
            { no: 3, name: "metric_type", kind: "enum", T: () => ["c1.api.tsdb.v1.MetricType", MetricType, "METRIC_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<MetricRollupRequestSet>): MetricRollupRequestSet {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requests = [];
        message.metricType = 0;
        if (value !== undefined)
            reflectionMergePartial<MetricRollupRequestSet>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MetricRollupRequestSet): MetricRollupRequestSet {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.tsdb.v1.MetricRollupRequest requests */ 1:
                    message.requests.push(MetricRollupRequest.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.api.tsdb.v1.AggregationType aggregation_type */ 2:
                    message.aggregationType = AggregationType.internalBinaryRead(reader, reader.uint32(), options, message.aggregationType);
                    break;
                case /* c1.api.tsdb.v1.MetricType metric_type */ 3:
                    message.metricType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MetricRollupRequestSet, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.tsdb.v1.MetricRollupRequest requests = 1; */
        for (let i = 0; i < message.requests.length; i++)
            MetricRollupRequest.internalBinaryWrite(message.requests[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.tsdb.v1.AggregationType aggregation_type = 2; */
        if (message.aggregationType)
            AggregationType.internalBinaryWrite(message.aggregationType, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.tsdb.v1.MetricType metric_type = 3; */
        if (message.metricType !== 0)
            writer.tag(3, WireType.Varint).int32(message.metricType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.tsdb.v1.MetricRollupRequestSet
 */
export const MetricRollupRequestSet = new MetricRollupRequestSet$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GaugeAverageAggregation$Type extends MessageType<GaugeAverageAggregation> {
    constructor() {
        super("c1.api.tsdb.v1.GaugeAverageAggregation", []);
    }
    create(value?: PartialMessage<GaugeAverageAggregation>): GaugeAverageAggregation {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GaugeAverageAggregation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GaugeAverageAggregation): GaugeAverageAggregation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GaugeAverageAggregation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.tsdb.v1.GaugeAverageAggregation
 */
export const GaugeAverageAggregation = new GaugeAverageAggregation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GaugePercentileAggregation$Type extends MessageType<GaugePercentileAggregation> {
    constructor() {
        super("c1.api.tsdb.v1.GaugePercentileAggregation", [
            { no: 1, name: "percentile", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100, gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<GaugePercentileAggregation>): GaugePercentileAggregation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.percentile = 0;
        if (value !== undefined)
            reflectionMergePartial<GaugePercentileAggregation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GaugePercentileAggregation): GaugePercentileAggregation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 percentile */ 1:
                    message.percentile = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GaugePercentileAggregation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 percentile = 1; */
        if (message.percentile !== 0)
            writer.tag(1, WireType.Varint).int32(message.percentile);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.tsdb.v1.GaugePercentileAggregation
 */
export const GaugePercentileAggregation = new GaugePercentileAggregation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AggregationType$Type extends MessageType<AggregationType> {
    constructor() {
        super("c1.api.tsdb.v1.AggregationType", [
            { no: 1, name: "gauge_average", kind: "message", oneof: "type", T: () => GaugeAverageAggregation },
            { no: 2, name: "gauge_percentile", kind: "message", oneof: "type", T: () => GaugePercentileAggregation }
        ]);
    }
    create(value?: PartialMessage<AggregationType>): AggregationType {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AggregationType>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AggregationType): AggregationType {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.tsdb.v1.GaugeAverageAggregation gauge_average */ 1:
                    message.type = {
                        oneofKind: "gaugeAverage",
                        gaugeAverage: GaugeAverageAggregation.internalBinaryRead(reader, reader.uint32(), options, (message.type as any).gaugeAverage)
                    };
                    break;
                case /* c1.api.tsdb.v1.GaugePercentileAggregation gauge_percentile */ 2:
                    message.type = {
                        oneofKind: "gaugePercentile",
                        gaugePercentile: GaugePercentileAggregation.internalBinaryRead(reader, reader.uint32(), options, (message.type as any).gaugePercentile)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AggregationType, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.tsdb.v1.GaugeAverageAggregation gauge_average = 1; */
        if (message.type.oneofKind === "gaugeAverage")
            GaugeAverageAggregation.internalBinaryWrite(message.type.gaugeAverage, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.tsdb.v1.GaugePercentileAggregation gauge_percentile = 2; */
        if (message.type.oneofKind === "gaugePercentile")
            GaugePercentileAggregation.internalBinaryWrite(message.type.gaugePercentile, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.tsdb.v1.AggregationType
 */
export const AggregationType = new AggregationType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MetricRollupRequest$Type extends MessageType<MetricRollupRequest> {
    constructor() {
        super("c1.api.tsdb.v1.MetricRollupRequest", [
            { no: 1, name: "metric_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "labels", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 3, name: "metric_type", kind: "enum", T: () => ["c1.api.tsdb.v1.MetricType", MetricType, "METRIC_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<MetricRollupRequest>): MetricRollupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.metricName = "";
        message.labels = {};
        message.metricType = 0;
        if (value !== undefined)
            reflectionMergePartial<MetricRollupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MetricRollupRequest): MetricRollupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string metric_name */ 1:
                    message.metricName = reader.string();
                    break;
                case /* map<string, string> labels */ 2:
                    this.binaryReadMap2(message.labels, reader, options);
                    break;
                case /* c1.api.tsdb.v1.MetricType metric_type = 3 [deprecated = true] */ 3:
                    message.metricType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: MetricRollupRequest["labels"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof MetricRollupRequest["labels"] | undefined, val: MetricRollupRequest["labels"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.tsdb.v1.MetricRollupRequest.labels");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: MetricRollupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string metric_name = 1; */
        if (message.metricName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.metricName);
        /* map<string, string> labels = 2; */
        for (let k of globalThis.Object.keys(message.labels))
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.labels[k]).join();
        /* c1.api.tsdb.v1.MetricType metric_type = 3 [deprecated = true]; */
        if (message.metricType !== 0)
            writer.tag(3, WireType.Varint).int32(message.metricType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.tsdb.v1.MetricRollupRequest
 */
export const MetricRollupRequest = new MetricRollupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TSDBMetricServiceGetRollupsRequest$Type extends MessageType<TSDBMetricServiceGetRollupsRequest> {
    constructor() {
        super("c1.api.tsdb.v1.TSDBMetricServiceGetRollupsRequest", [
            { no: 1, name: "metric_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "start_time", kind: "message", T: () => Timestamp },
            { no: 3, name: "end_time", kind: "message", T: () => Timestamp },
            { no: 4, name: "labels", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 5, name: "metric_type", kind: "enum", T: () => ["c1.api.tsdb.v1.MetricType", MetricType, "METRIC_TYPE_"] },
            { no: 6, name: "target_point_density", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "aggregation_type", kind: "message", T: () => AggregationType }
        ]);
    }
    create(value?: PartialMessage<TSDBMetricServiceGetRollupsRequest>): TSDBMetricServiceGetRollupsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.metricName = "";
        message.labels = {};
        message.metricType = 0;
        if (value !== undefined)
            reflectionMergePartial<TSDBMetricServiceGetRollupsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TSDBMetricServiceGetRollupsRequest): TSDBMetricServiceGetRollupsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string metric_name */ 1:
                    message.metricName = reader.string();
                    break;
                case /* google.protobuf.Timestamp start_time */ 2:
                    message.startTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startTime);
                    break;
                case /* google.protobuf.Timestamp end_time */ 3:
                    message.endTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.endTime);
                    break;
                case /* map<string, string> labels */ 4:
                    this.binaryReadMap4(message.labels, reader, options);
                    break;
                case /* c1.api.tsdb.v1.MetricType metric_type */ 5:
                    message.metricType = reader.int32();
                    break;
                case /* optional int32 target_point_density */ 6:
                    message.targetPointDensity = reader.int32();
                    break;
                case /* c1.api.tsdb.v1.AggregationType aggregation_type */ 7:
                    message.aggregationType = AggregationType.internalBinaryRead(reader, reader.uint32(), options, message.aggregationType);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap4(map: TSDBMetricServiceGetRollupsRequest["labels"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof TSDBMetricServiceGetRollupsRequest["labels"] | undefined, val: TSDBMetricServiceGetRollupsRequest["labels"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.tsdb.v1.TSDBMetricServiceGetRollupsRequest.labels");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: TSDBMetricServiceGetRollupsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string metric_name = 1; */
        if (message.metricName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.metricName);
        /* google.protobuf.Timestamp start_time = 2; */
        if (message.startTime)
            Timestamp.internalBinaryWrite(message.startTime, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp end_time = 3; */
        if (message.endTime)
            Timestamp.internalBinaryWrite(message.endTime, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> labels = 4; */
        for (let k of globalThis.Object.keys(message.labels))
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.labels[k]).join();
        /* c1.api.tsdb.v1.MetricType metric_type = 5; */
        if (message.metricType !== 0)
            writer.tag(5, WireType.Varint).int32(message.metricType);
        /* optional int32 target_point_density = 6; */
        if (message.targetPointDensity !== undefined)
            writer.tag(6, WireType.Varint).int32(message.targetPointDensity);
        /* c1.api.tsdb.v1.AggregationType aggregation_type = 7; */
        if (message.aggregationType)
            AggregationType.internalBinaryWrite(message.aggregationType, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.tsdb.v1.TSDBMetricServiceGetRollupsRequest
 */
export const TSDBMetricServiceGetRollupsRequest = new TSDBMetricServiceGetRollupsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TSDBMetricServiceGetRollupsResponse$Type extends MessageType<TSDBMetricServiceGetRollupsResponse> {
    constructor() {
        super("c1.api.tsdb.v1.TSDBMetricServiceGetRollupsResponse", [
            { no: 1, name: "granularity", kind: "enum", T: () => ["c1.api.tsdb.v1.Granularity", Granularity] },
            { no: 2, name: "rollups", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Rollup },
            { no: 4, name: "first_observed_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "metric_found", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "aggregate_value", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<TSDBMetricServiceGetRollupsResponse>): TSDBMetricServiceGetRollupsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.granularity = 0;
        message.rollups = [];
        message.metricFound = false;
        message.aggregateValue = 0;
        if (value !== undefined)
            reflectionMergePartial<TSDBMetricServiceGetRollupsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TSDBMetricServiceGetRollupsResponse): TSDBMetricServiceGetRollupsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.tsdb.v1.Granularity granularity */ 1:
                    message.granularity = reader.int32();
                    break;
                case /* repeated c1.api.tsdb.v1.Rollup rollups */ 2:
                    message.rollups.push(Rollup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp first_observed_at */ 4:
                    message.firstObservedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.firstObservedAt);
                    break;
                case /* bool metric_found */ 6:
                    message.metricFound = reader.bool();
                    break;
                case /* int64 aggregate_value */ 7:
                    message.aggregateValue = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TSDBMetricServiceGetRollupsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.tsdb.v1.Granularity granularity = 1; */
        if (message.granularity !== 0)
            writer.tag(1, WireType.Varint).int32(message.granularity);
        /* repeated c1.api.tsdb.v1.Rollup rollups = 2; */
        for (let i = 0; i < message.rollups.length; i++)
            Rollup.internalBinaryWrite(message.rollups[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp first_observed_at = 4; */
        if (message.firstObservedAt)
            Timestamp.internalBinaryWrite(message.firstObservedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool metric_found = 6; */
        if (message.metricFound !== false)
            writer.tag(6, WireType.Varint).bool(message.metricFound);
        /* int64 aggregate_value = 7; */
        if (message.aggregateValue !== 0)
            writer.tag(7, WireType.Varint).int64(message.aggregateValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.tsdb.v1.TSDBMetricServiceGetRollupsResponse
 */
export const TSDBMetricServiceGetRollupsResponse = new TSDBMetricServiceGetRollupsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Rollup$Type extends MessageType<Rollup> {
    constructor() {
        super("c1.api.tsdb.v1.Rollup", [
            { no: 1, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "value", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "data_available", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "data_collection_pending", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Rollup>): Rollup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.value = 0;
        message.dataAvailable = false;
        message.dataCollectionPending = false;
        if (value !== undefined)
            reflectionMergePartial<Rollup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Rollup): Rollup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp timestamp */ 1:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* int64 value */ 2:
                    message.value = reader.int64().toNumber();
                    break;
                case /* bool data_available */ 3:
                    message.dataAvailable = reader.bool();
                    break;
                case /* bool data_collection_pending */ 4:
                    message.dataCollectionPending = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Rollup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp timestamp = 1; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 value = 2; */
        if (message.value !== 0)
            writer.tag(2, WireType.Varint).int64(message.value);
        /* bool data_available = 3; */
        if (message.dataAvailable !== false)
            writer.tag(3, WireType.Varint).bool(message.dataAvailable);
        /* bool data_collection_pending = 4; */
        if (message.dataCollectionPending !== false)
            writer.tag(4, WireType.Varint).bool(message.dataCollectionPending);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.tsdb.v1.Rollup
 */
export const Rollup = new Rollup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TSDBMetricServiceGetManyMetricsResponse$Type extends MessageType<TSDBMetricServiceGetManyMetricsResponse> {
    constructor() {
        super("c1.api.tsdb.v1.TSDBMetricServiceGetManyMetricsResponse", [
            { no: 1, name: "metric_rollups", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MetricRollupResponse },
            { no: 2, name: "granularity", kind: "enum", T: () => ["c1.api.tsdb.v1.Granularity", Granularity] },
            { no: 3, name: "aggregate_value", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<TSDBMetricServiceGetManyMetricsResponse>): TSDBMetricServiceGetManyMetricsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.metricRollups = [];
        message.granularity = 0;
        if (value !== undefined)
            reflectionMergePartial<TSDBMetricServiceGetManyMetricsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TSDBMetricServiceGetManyMetricsResponse): TSDBMetricServiceGetManyMetricsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.tsdb.v1.MetricRollupResponse metric_rollups */ 1:
                    message.metricRollups.push(MetricRollupResponse.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.api.tsdb.v1.Granularity granularity */ 2:
                    message.granularity = reader.int32();
                    break;
                case /* optional int64 aggregate_value */ 3:
                    message.aggregateValue = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TSDBMetricServiceGetManyMetricsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.tsdb.v1.MetricRollupResponse metric_rollups = 1; */
        for (let i = 0; i < message.metricRollups.length; i++)
            MetricRollupResponse.internalBinaryWrite(message.metricRollups[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.tsdb.v1.Granularity granularity = 2; */
        if (message.granularity !== 0)
            writer.tag(2, WireType.Varint).int32(message.granularity);
        /* optional int64 aggregate_value = 3; */
        if (message.aggregateValue !== undefined)
            writer.tag(3, WireType.Varint).int64(message.aggregateValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.tsdb.v1.TSDBMetricServiceGetManyMetricsResponse
 */
export const TSDBMetricServiceGetManyMetricsResponse = new TSDBMetricServiceGetManyMetricsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MetricRollupResponse$Type extends MessageType<MetricRollupResponse> {
    constructor() {
        super("c1.api.tsdb.v1.MetricRollupResponse", [
            { no: 1, name: "metric_name", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "rollups", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Rollup },
            { no: 3, name: "metric_found", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "first_observed_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "aggregate_value", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<MetricRollupResponse>): MetricRollupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.metricName = [];
        message.rollups = [];
        message.metricFound = false;
        message.aggregateValue = 0;
        if (value !== undefined)
            reflectionMergePartial<MetricRollupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MetricRollupResponse): MetricRollupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string metric_name */ 1:
                    message.metricName.push(reader.string());
                    break;
                case /* repeated c1.api.tsdb.v1.Rollup rollups */ 2:
                    message.rollups.push(Rollup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool metric_found */ 3:
                    message.metricFound = reader.bool();
                    break;
                case /* google.protobuf.Timestamp first_observed_at */ 4:
                    message.firstObservedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.firstObservedAt);
                    break;
                case /* int64 aggregate_value */ 5:
                    message.aggregateValue = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MetricRollupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string metric_name = 1; */
        for (let i = 0; i < message.metricName.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.metricName[i]);
        /* repeated c1.api.tsdb.v1.Rollup rollups = 2; */
        for (let i = 0; i < message.rollups.length; i++)
            Rollup.internalBinaryWrite(message.rollups[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool metric_found = 3; */
        if (message.metricFound !== false)
            writer.tag(3, WireType.Varint).bool(message.metricFound);
        /* google.protobuf.Timestamp first_observed_at = 4; */
        if (message.firstObservedAt)
            Timestamp.internalBinaryWrite(message.firstObservedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int64 aggregate_value = 5; */
        if (message.aggregateValue !== 0)
            writer.tag(5, WireType.Varint).int64(message.aggregateValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.tsdb.v1.MetricRollupResponse
 */
export const MetricRollupResponse = new MetricRollupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserResponseTimeStatsRequest$Type extends MessageType<GetUserResponseTimeStatsRequest> {
    constructor() {
        super("c1.api.tsdb.v1.GetUserResponseTimeStatsRequest", [
            { no: 1, name: "task_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskType },
            { no: 2, name: "start_time", kind: "message", T: () => Timestamp },
            { no: 3, name: "end_time", kind: "message", T: () => Timestamp },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100, gte: 1 } } } },
            { no: 5, name: "sort_column", kind: "enum", T: () => ["c1.api.tsdb.v1.UserResponseTimeSortColumn", UserResponseTimeSortColumn, "USER_RESPONSE_TIME_SORT_COLUMN_"] },
            { no: 6, name: "sort_direction", kind: "enum", T: () => ["c1.models.api.v1.SortDirection", SortDirection, "SORT_DIRECTION_"] },
            { no: 7, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetUserResponseTimeStatsRequest>): GetUserResponseTimeStatsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taskTypes = [];
        message.pageSize = 0;
        message.sortColumn = 0;
        message.sortDirection = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<GetUserResponseTimeStatsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetUserResponseTimeStatsRequest): GetUserResponseTimeStatsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.task.v1.TaskType task_types */ 1:
                    message.taskTypes.push(TaskType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp start_time */ 2:
                    message.startTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startTime);
                    break;
                case /* google.protobuf.Timestamp end_time */ 3:
                    message.endTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.endTime);
                    break;
                case /* int32 page_size */ 4:
                    message.pageSize = reader.int32();
                    break;
                case /* c1.api.tsdb.v1.UserResponseTimeSortColumn sort_column */ 5:
                    message.sortColumn = reader.int32();
                    break;
                case /* c1.models.api.v1.SortDirection sort_direction */ 6:
                    message.sortDirection = reader.int32();
                    break;
                case /* string page_token */ 7:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetUserResponseTimeStatsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.task.v1.TaskType task_types = 1; */
        for (let i = 0; i < message.taskTypes.length; i++)
            TaskType.internalBinaryWrite(message.taskTypes[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp start_time = 2; */
        if (message.startTime)
            Timestamp.internalBinaryWrite(message.startTime, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp end_time = 3; */
        if (message.endTime)
            Timestamp.internalBinaryWrite(message.endTime, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* int32 page_size = 4; */
        if (message.pageSize !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageSize);
        /* c1.api.tsdb.v1.UserResponseTimeSortColumn sort_column = 5; */
        if (message.sortColumn !== 0)
            writer.tag(5, WireType.Varint).int32(message.sortColumn);
        /* c1.models.api.v1.SortDirection sort_direction = 6; */
        if (message.sortDirection !== 0)
            writer.tag(6, WireType.Varint).int32(message.sortDirection);
        /* string page_token = 7; */
        if (message.pageToken !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.tsdb.v1.GetUserResponseTimeStatsRequest
 */
export const GetUserResponseTimeStatsRequest = new GetUserResponseTimeStatsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserResponseTimeStatsResponse$Type extends MessageType<GetUserResponseTimeStatsResponse> {
    constructor() {
        super("c1.api.tsdb.v1.GetUserResponseTimeStatsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserResponseTimeEntry },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetUserResponseTimeStatsResponse>): GetUserResponseTimeStatsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial<GetUserResponseTimeStatsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetUserResponseTimeStatsResponse): GetUserResponseTimeStatsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.tsdb.v1.UserResponseTimeEntry list */ 1:
                    message.list.push(UserResponseTimeEntry.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* int32 total_count */ 3:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetUserResponseTimeStatsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.tsdb.v1.UserResponseTimeEntry list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UserResponseTimeEntry.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* int32 total_count = 3; */
        if (message.totalCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.tsdb.v1.GetUserResponseTimeStatsResponse
 */
export const GetUserResponseTimeStatsResponse = new GetUserResponseTimeStatsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserResponseTimeEntry$Type extends MessageType<UserResponseTimeEntry> {
    constructor() {
        super("c1.api.tsdb.v1.UserResponseTimeEntry", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "total_actions", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "p50_seconds", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "p90_seconds", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 5, name: "p99_seconds", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<UserResponseTimeEntry>): UserResponseTimeEntry {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        message.totalActions = 0;
        message.p50Seconds = 0;
        message.p90Seconds = 0;
        message.p99Seconds = 0;
        if (value !== undefined)
            reflectionMergePartial<UserResponseTimeEntry>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserResponseTimeEntry): UserResponseTimeEntry {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* int64 total_actions */ 2:
                    message.totalActions = reader.int64().toNumber();
                    break;
                case /* int64 p50_seconds */ 3:
                    message.p50Seconds = reader.int64().toNumber();
                    break;
                case /* int64 p90_seconds */ 4:
                    message.p90Seconds = reader.int64().toNumber();
                    break;
                case /* int64 p99_seconds */ 5:
                    message.p99Seconds = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserResponseTimeEntry, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* int64 total_actions = 2; */
        if (message.totalActions !== 0)
            writer.tag(2, WireType.Varint).int64(message.totalActions);
        /* int64 p50_seconds = 3; */
        if (message.p50Seconds !== 0)
            writer.tag(3, WireType.Varint).int64(message.p50Seconds);
        /* int64 p90_seconds = 4; */
        if (message.p90Seconds !== 0)
            writer.tag(4, WireType.Varint).int64(message.p90Seconds);
        /* int64 p99_seconds = 5; */
        if (message.p99Seconds !== 0)
            writer.tag(5, WireType.Varint).int64(message.p99Seconds);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.tsdb.v1.UserResponseTimeEntry
 */
export const UserResponseTimeEntry = new UserResponseTimeEntry$Type();
/**
 * @generated ServiceType for protobuf service c1.api.tsdb.v1.TSDBMetricsService
 */
export const TSDBMetricsService = new ServiceType("c1.api.tsdb.v1.TSDBMetricsService", [
    { name: "GetRollups", options: { "authz.method": { role: "VIEWER" } }, I: TSDBMetricServiceGetRollupsRequest, O: TSDBMetricServiceGetRollupsResponse },
    { name: "GetManyMetricsRollups", options: { "authz.method": { role: "VIEWER" } }, I: TSDBMetricServiceGetManyMetricsRequest, O: TSDBMetricServiceGetManyMetricsResponse },
    { name: "GetTopValues", options: { "authz.method": { role: "VIEWER" } }, I: TSDBMetricServiceGetTopValuesRequest, O: TSDBMetricServiceGetTopValuesResponse },
    { name: "GetUserResponseTimeStats", options: { "authz.method": { role: "VIEWER" } }, I: GetUserResponseTimeStatsRequest, O: GetUserResponseTimeStatsResponse }
]);
